"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var easy_peasy_1 = require("easy-peasy");
var storage_1 = __importDefault(require("../../helpers/storage"));
var permission = {
    permissions: [],
    loadPermissions: easy_peasy_1.action(function (state, permissions) {
        state.permissions = permissions;
    }),
    username: storage_1.default.getLoggedUser(),
    isUserAuthenticated: storage_1.default.getApiToken() !== null,
    userAuthenticated: easy_peasy_1.action(function (state, values) {
        storage_1.default.setApiToken(values.accessToken);
        state.username = values.username;
        state.isUserAuthenticated = values.username !== null && values.username !== undefined && !!values.accessToken;
    }),
    setUserName: easy_peasy_1.action(function (state, values) {
        state.username = values;
    }),
    removeAuthenticated: easy_peasy_1.action(function (state) {
        state.username = null;
        state.isUserAuthenticated = false;
    }),
};
exports.default = permission;
